export default __webpack_public_path__ + "static/B0107-d2656bc7d804ad670808190d379dec48.png";